
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAlertFloatingItem as ObcAlertFloatingItemElement} from '@oicl/openbridge-webcomponents/dist/components/alert-floating-item/alert-floating-item.js';
 
 
 

 
 export const ObcAlertFloatingItem = createComponent({
   react: React,
   tagName: 'obc-alert-floating-item',
   elementClass: ObcAlertFloatingItemElement,
   events: {
     
   }
  });
 
 